import React, { useEffect, useRef, useState } from 'react';
import styles from './Agreement.module.css';
import useApiFetcher from '../../../hooks/useApiFetcher';

const Agreement = ({
  isSpeaking, isListening, isThinking,
  setIndex,
  setShowFinalSummaryScreen,
  labels,
  status,
  priceArr,
  monthlyPayment,
  totalPrice,
  apiData,
  userQueriesHistory,
  lastScreen,
  setBackButtonClicked
}) => {
  const { apiFetcher } = useApiFetcher();
  const [emailSent, setEmailSent] = useState(false);
  const [sending, setSending] = useState(false);

  const handleFinish = async () => {
    setSending(true);
    const agreementData = {
      customerName: apiData?.deal.custId.customerName,
      selectedProducts: selectedProducts.map((product) => ({
        name: product.name,
        price: product.price,
      })),
      unselectedProducts: unselectedProducts.map((product) => ({
        name: product.name,
        price: product.price,
      })),
      totalPrice: discountTotalPayment, // Total selected products price
      loanAmount: apiData?.deal.financeAmount, // Loan Amount
      monthlyPayment: monthlyPayment.toFixed(2), // Monthly Payment
      interestRate: apiData?.deal.intrestedRate, // Interest Rate
      discountPercentage: discountPercentage, // Optional: Discount Percentage
      deal: apiData?.deal,
    };

    try {
      await apiFetcher("/multi-stepper/send-email", "POST", {
        recipientEmail: apiData?.deal.custId.email, // The recipient email
        agreementData, // Agreement data containing all relevant info,
      });
      setEmailSent(true);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setSending(false);
    }
  };
  // const prevHistoryLength = useRef(userQueriesHistory.length);

  // useEffect(() => {
  //   const sendEmailToDealerAdmin = async () => {
  //     try {
  //       await apiFetcher("/multi-stepper/send-email-to-dealeradmin", "POST", {
  //         userQueriesHistory,
  //         customerData: apiData?.deal.custId,
  //         dealerEmail: apiData?.dealerEmail
  //       });
  //     } catch (error) {
  //       console.error('Error:', error);
  //     }
  //   };

  //   if (userQueriesHistory.length > prevHistoryLength.current) {
  //     sendEmailToDealerAdmin();
  //     prevHistoryLength.current = userQueriesHistory.length; // Update reference
  //   }
  // }, [userQueriesHistory]);
  const products = labels.map((label, index) => ({
    id: index,
    name: label,
    isSelected: status[index],
    price: priceArr[index],
  }));

  const selectedProducts = products.filter((product) => product.isSelected);
  const unselectedProducts = products.filter((product) => !product.isSelected);

  const selectedTotalPrice = selectedProducts.reduce(
    (acc, product) => acc + product.price,
    0
  );
  const allSelected = status.every(array => array === true);
  const summaryStep = apiData?.getScript?.steps.find(
    (step) => step.type === "Summary Script"
  );
  const discountPercentage = Number(summaryStep?.discountPercent);
  const discountTotalPayment = allSelected
    ? selectedTotalPrice * (1 - discountPercentage / 100)
    : selectedTotalPrice;


  const backHandler = () => {
    setIndex((prev) => prev - 1);
    lastScreen = false
    setShowFinalSummaryScreen(false);
    setBackButtonClicked(true)
  };


  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2>Purchase and Financial Services Summary</h2>
        <p><strong>{apiData?.deal.custId.customerName}</strong></p>
        <p>{`${apiData?.deal.carId.carName} ${apiData?.deal.carId.colorDetails.name}`}</p>
      </div>
      <div className={styles.financeSection}>
        <h2>{apiData?.deal?.dealershipId?.dealershipName}</h2>
        <p>{apiData?.deal.financeDuration} Month Simple Interest ({apiData?.deal.intrestedRate}% APR) Retail Installment Contract</p>
        <p>
          Base Amount Financed (no options): <strong>${apiData?.deal.financeAmount}</strong>
        </p>
        <p>
          Down Payment:{" "}
          <strong>{apiData?.deal.downpayment}</strong>
        </p>
        {/* <p>
          Base Payment (no options):{" "}
          <strong>${apiData?.deal.base}</strong>
        </p> */}
      </div>
      {/* <div className={styles.customerInfo}>
        <h2>Customer Name: {apiData?.deal.custId.customerName}</h2>
      </div> */}

      <div className={styles.optionsColumn}>
        {/* Selected Products Section */}
        <div className={`${styles.sectionBox} ${styles.selectedOptions}`}>
          <h2>Selected Products</h2>
          <ul className={styles.productList}>
            {selectedProducts.map((product) => (
              <li key={product.id} className={styles.productItem}>
                <span>{product.name}</span>
                <span className={styles.price}>
                  ${product.price}
                </span>
              </li>
            ))}
            {/* <li className={styles.productItem}>
              <span>Total Price</span>
              <span className={styles.price}>${selectedTotalPrice}</span>
              <span>+</span>
              <span>Loan Amount</span>
              <span className={styles.price}>{apiData?.deal.financeAmount}</span>
            </li> */}
            {/* <li className={styles.productItem}>
              <span>Monthly Price </span>
              <span className={styles.price}>${monthlyPayment.toFixed(2)}</span>
              <span>with Interest Rate of </span>
              <span className={styles.price}>{apiData?.deal.intrestedRate}%</span>
            </li> */}
          </ul>
        </div>

        {/* Unselected Products Section */}
        <div className={`${styles.sectionBox} ${styles.declinedOptions}`}>
          <h2>Unselected Products</h2>
          <ul className={styles.productList}>
            {unselectedProducts.map((product) => (
              <li key={product.id} className={styles.productItem}>
                <span>{product.name}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className={`${styles.sectionBox} ${styles.finalLoan}`}>
          <h3>Final Loan Structure</h3>
          <p>Total Amount of Products: ${discountTotalPayment} {allSelected ? `with ${discountPercentage}% Discount` : " "}</p>
          <p>Monthly Payment: ${monthlyPayment.toFixed(2)}</p>
        </div>
      </div>

      <div className={styles.buttonCon}>
        {isSpeaking && !isListening && !isThinking &&
          <>
            <button className={styles.buttonBack} onClick={backHandler}>
              Back
            </button>
            <button 
              onClick={handleFinish} 
              disabled={sending || emailSent}
              style={{
                marginLeft: '15px',
                padding: '8px 24px',
                backgroundColor: emailSent ? '#10b981' : '#3b82f6',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontWeight: '600',
                cursor: (sending || emailSent) ? 'not-allowed' : 'pointer',
                opacity: (sending) ? 0.7 : 1,
                transition: 'all 0.3s ease'
              }}
            >
              {sending ? 'Sending...' : emailSent ? 'Invoice Sent' : 'Finish & Send Invoice'}
            </button>
          </>
        }
      </div>
    </div>
  );
};

export default Agreement;
